import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {DateString} from "./Projects";

export class Payables extends SubAPI {

    list(props: {
        offset?: number;
        search?: string;
        status?: "paid" | "draft" | "needs-quickbooks-sync" | "pending-approval";
    }) {
        return this.fetcher.get<Paginated<Payable>>("/api/payables", props);
    }

    get(props: {id: number}) {
        return this.fetcher.get<Payable>("/api/payable", props);
    }

    upsert(input: Partial<Payable> & {
        importPos?: number[];
    }) {
        return this.fetcher.post<Payable>("/api/payable", input);
    }

    listItems(props: {
        offset?: number;
        payable: number;
    }) {
        return this.fetcher.get<Paginated<PayableItem>>("/api/payable/items", props);
    }

    upsertItem(input: Partial<PayableItem>) {
        return this.fetcher.post<PayableItem>("/api/payable/item", input);
    }

    setPoLinks(input: {
        id: number;
        linkedPos: number[]
    }) {
        return this.fetcher.post<Payable>("/api/payable/set-po-links", input);
    }

    removeAttachment(input: {
        payable: number;
        file: number;
    }) {
        return this.fetcher.post("/api/payable/remove-attachment", input);
    }

    uploadAttachment(input: {
        id: number;
        file: File;
    }) {
        return this.fetcher.postFormData("/api/payable/upload-attachment", {
            id: input.id.toString(),
            file: input.file,
        })
    }
    
    approve(input: {
        payable: number;
        approved: boolean;
    }) {
        return this.fetcher.post("/api/payable/approve", input);
    }
    
    quickbooksSync(input: {
        payable: number;
    }) {
        return this.fetcher.post("/api/payable/quickbooks-sync", input)
    }
}

export type Payable = {
    id: number;

    vendor: number;
    vendorInvoiceNumber: string;
    vendorName: string;

    invoiceDate: string;
    dueDate: string | null;

    status: string;

    archived: boolean;
    totalCents: number;

    createdAt: DateString;
    updatedAt: DateString;
    updatedBy: number;

    approvedBy: number | null;
    approvedByName: string | null;
    approvedAt: DateString | null;
    autoApproved: boolean;

    quickbooksSyncComplete: boolean;

    linkedPurchaseOrders: {
        id: number;
        poNumber: string;
    }[];

    attachments: {
        id: number;
        name: string;
    }[];
}

export type PayableItem = {
    id: number;
    payable: number;
    purchaseOrderItem?: number | null;
    purchaseOrderNumber?: string | null;
    description: string;
    qty: number;
    unitAmountCents: number;
    archived: boolean;
    createdAt: DateString;
    updatedAt: DateString;
    updatedBy: number;
    maxQty?: number | null;
}